const axios = require('axios');
const { baseUrlNew, buildAuthHeaders } = require('./settings.js');

exports.fetchUsersOfCompany = function () {
  return axios.get(baseUrlNew + 'user', {
    headers: buildAuthHeaders()
  });
};

exports.fetchUsersListForScheduledReports = function () {
  return axios.get(baseUrlNew + 'user/for-report', {
    headers: buildAuthHeaders()
  });
};
